export default __webpack_public_path__ + "static/media/documentIcon.d95a60aa.svg";